"use client";

import { FileText, Stethoscope, Database } from "lucide-react";
import { motion } from "framer-motion";
import { AnimatedCounter } from "@/components/common/animated-counter";
import { EASE_OUT_EXPO } from "@/lib/animations";

interface TrustBannerProps {
  totalProcedures: number;
  totalArticles?: number;
}

export function TrustBanner({ totalProcedures, totalArticles = 45000 }: TrustBannerProps) {
  return (
    <div className="relative z-10 -mt-6 px-5">
      <div className="grid grid-cols-3 gap-3">
        {[
          { icon: FileText, key: "articles" as const, label: "논문 분석" },
          { icon: Database, key: "procedures" as const, label: "시술 수록" },
          { icon: Stethoscope, key: "ai" as const, label: "AI 분석" },
        ].map((item, i) => (
          <motion.div
            key={item.key}
            initial={{ opacity: 0, y: 24, scale: 0.95 }}
            whileInView={{ opacity: 1, y: 0, scale: 1 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.1, duration: 0.5, ease: EASE_OUT_EXPO }}
            className="relative overflow-hidden rounded-2xl border border-gray-100 bg-white p-5 text-center shadow-md shadow-gray-100/60"
          >
            <item.icon
              className="absolute -top-1 -right-1 h-14 w-14 text-violet-100 opacity-30"
              strokeWidth={1}
            />
            <div className="relative">
              {item.key === "articles" ? (
                <AnimatedCounter
                  value={totalArticles}
                  format={(n) => (n >= 10000 ? `${(n / 10000).toFixed(1)}만` : `${n}`)}
                  className="text-[26px] font-extrabold tracking-tight text-gray-900"
                />
              ) : item.key === "procedures" ? (
                <AnimatedCounter
                  value={totalProcedures}
                  className="text-[26px] font-extrabold tracking-tight text-gray-900"
                />
              ) : (
                <span className="text-[26px] font-extrabold tracking-tight text-gray-900">
                  실시간
                </span>
              )}
              <span className="text-muted-foreground mt-1 block text-xs font-semibold tracking-wider uppercase">
                {item.label}
              </span>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
